import {
  VehicleCategories,
  VehicleCategoryTypes,
  PrequalFinanceProviderCodes,
  PrequalFinanceProviderTypes,
} from './enums';

export const prequalFinanceProviderMap = [
  {
    categoryType: VehicleCategoryTypes.AUTO,
    providerCode: PrequalFinanceProviderCodes.TD,
    providerType: PrequalFinanceProviderTypes.TD,
  },
  {
    categoryType: VehicleCategoryTypes.AUTO,
    providerCode: PrequalFinanceProviderCodes.GL,
    providerType: PrequalFinanceProviderTypes.GL,
  },
  {
    categoryType: VehicleCategoryTypes.RECREATIONAL,
    category: VehicleCategories.RV,
    providerCode: PrequalFinanceProviderCodes.TD_RV,
    providerType: PrequalFinanceProviderTypes.TD,
  },
  {
    categoryType: VehicleCategoryTypes.RECREATIONAL,
    category: VehicleCategories.RV,
    providerCode: PrequalFinanceProviderCodes.GL_RV,
    providerType: PrequalFinanceProviderTypes.GL,
  },
  {
    categoryType: VehicleCategoryTypes.RECREATIONAL,
    category: VehicleCategories.MARINE,
    providerCode: PrequalFinanceProviderCodes.TD_MARINE,
    providerType: PrequalFinanceProviderTypes.TD,
  },
  {
    categoryType: VehicleCategoryTypes.RECREATIONAL,
    category: VehicleCategories.MARINE,
    providerCode: PrequalFinanceProviderCodes.GL_MARINE,
    providerType: PrequalFinanceProviderTypes.GL,
  },
  {
    categoryType: VehicleCategoryTypes.RECREATIONAL,
    category: VehicleCategories.POWERSPORTS,
    providerCode: PrequalFinanceProviderCodes.TD_POWERSPORTS,
    providerType: PrequalFinanceProviderTypes.TD,
  },
  {
    categoryType: VehicleCategoryTypes.RECREATIONAL,
    category: VehicleCategories.POWERSPORTS,
    providerCode: PrequalFinanceProviderCodes.GL_POWERSPORTS,
    providerType: PrequalFinanceProviderTypes.GL,
  },
];

export default prequalFinanceProviderMap;
